import { useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { HeaderType } from "../../types/HeaderType";
import { Messages } from "primereact/messages";
import { useSearchParams } from "react-router-dom";
import { getDefectStatusValue } from "../../utils/DefectsTableDataHelper";

type Props = {
    headerType: HeaderType;
};

export const SearchParamMessage = (props: Props) => {
    const { headerType } = props;
    const { t } = useTranslation("locale");

    const messages = useRef<Messages>(null);
    const [searchParams] = useSearchParams();

    const enabled = useMemo(
        () =>
            headerType === HeaderType.DEFECTS ||
            headerType === HeaderType.SHARED_DEFECTS,
        [headerType]
    );

    useEffect(() => {
        if (enabled && messages.current) {
            const statusParam = searchParams.get("status");
            const evidenceParam = searchParams.get("evidence");

            if (statusParam) {
                let message = t("defectsTable.defectsSelected", {
                    status: getDefectStatusValue(statusParam)
                });

                if (evidenceParam) {
                    message = t("defectsTable.defectsWithoutEvidence");
                }

                messages.current.clear();
                messages.current.show({
                    sticky: true,
                    severity: "info",
                    closable: true,
                    detail: (
                        <p>
                            {t("defectsTable.showing")}
                            <b>{message}</b>
                            {t("defectsTable.resetTableOption")}
                        </p>
                    )
                });
            }
        }
    }, [searchParams, enabled]);

    if (!enabled) {
        return null;
    }

    return <Messages ref={messages} />;
};
